import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ReportBajaSinComision, ReportBaseComision, ReportBaseEmpleado } from 'src/app/model/nomina-models';
import { CatalogInfo, CustomResponseObject } from 'src/app/model/promotion-models';

export interface NominaReportRequest {
  fechaEjecucion: string;   // yyyy-MM-dd
  fechaCobro: string;       // yyyy-MM-dd
  periodoInicio: string;    // yyyy-MM-dd HH:mm:ss
  periodoFin: string;       // yyyy-MM-dd HH:mm:ss
  session: string;
}

@Injectable({
  providedIn: "root",
})
export class NominaService {
  private url: string;

  constructor(private http: HttpClient) {
    this.url = environment.services_url;
  }

  getReportBajasSinComisionSince(sinceDate: String) {
    return this.http.get<CustomResponseObject<CatalogInfo[]>>(
      `${this.url}/nomina/reports/bajas/${sinceDate}`
    );
  }

  getReportBajasSinComision() {
    return this.http.get<CustomResponseObject<ReportBajaSinComision[]>>(
      `${this.url}/nomina/reports/bajas`
    );
  }

  getReportBajasBaseEmpleado(
    initDate: String,
    lastDate: String,
    typeAsesors: String
  ) {
    return this.http.get<CustomResponseObject<ReportBaseEmpleado[]>>(
      `${this.url}/nomina/reports/baseEmpleado/${initDate}/${lastDate}/${typeAsesors}`
    );
  }

  getReportBajasBaseComision(
    initDate: String,
    lastDate: String,
    typeAsesors: String
  ) {
    return this.http.get<CustomResponseObject<ReportBaseComision[]>>(
      `${this.url}/nomina/reports/baseComision/${initDate}/${lastDate}/${typeAsesors}`
    );
  }

  getReportBajasBaseEmpleadoSession(nominaReportRequest: NominaReportRequest) {
    return this.http.post<CustomResponseObject<ReportBaseEmpleado[]>>(`${this.url}/nomina/reports/baseEmpleado`, nominaReportRequest);
  }

  getReportBajasBaseComisionSession(nominaReportRequest: NominaReportRequest) {
    return this.http.post<CustomResponseObject<ReportBaseComision[]>>(`${this.url}/nomina/reports/baseComision`, nominaReportRequest);
  }

  releasePayment(asesorId: String, date: String, simulated: boolean) {
    return this.http.get<CustomResponseObject<ReportBaseEmpleado>>(
      `${this.url}/nomina/reports/releasePayment/${asesorId}/${date}/${simulated}`
    );
  }
}